import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TopBar, BottomBar } from "@/components/Nav";
import { ProfileSetupModal, BadgeToast } from "@/components/Profile";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { SubProvider } from "@/lib/subscription";
import Home from "@/pages/Home";
import Learn from "@/pages/Learn";
import Play from "@/pages/Play";
import Progress from "@/pages/Progress";
import Parent from "@/pages/Parent";
import Pricing from "@/pages/Pricing";
import Help from "@/pages/Help";
import SectionPage from "@/pages/SectionPage";
import Memory from "@/pages/games/Memory";
import CatchStars from "@/pages/games/CatchStars";
import { FindObjectGame, SortMatchGame } from "@/pages/games/MiniGames";
import { PatternGame, CopycatGame, ShadowGame, DifferentGame } from "@/pages/games/Games";
import { GameGate } from "@/components/UpgradeGate";

function Shell({ children, title }) {
  return (<><TopBar title={title} />{children}<BottomBar /></>);
}
const Bare = ({ children }) => (<>{children}<BottomBar /></>);

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <SubProvider>
        <ProfileSetupModal />
        <BadgeToast />
        <Toaster position="bottom-center" richColors />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/learn" element={<Shell title="Learn"><Learn /></Shell>} />
          <Route path="/play" element={<Shell title="Play"><Play /></Shell>} />
          <Route path="/progress" element={<Shell title="Progress"><Progress /></Shell>} />
          <Route path="/parent" element={<Shell title="Parent"><Parent /></Shell>} />
          <Route path="/pricing" element={<Shell title="Pricing"><Pricing /></Shell>} />
          <Route path="/help" element={<Shell title="Help / Contact Us"><Help /></Shell>} />

          <Route path="/learn/:sectionId" element={<Bare><SectionPage /></Bare>} />

          <Route path="/play/memory" element={<Bare><Memory /></Bare>} />
          <Route path="/play/catch-stars" element={<Bare><CatchStars /></Bare>} />
          <Route path="/play/find-object" element={<Bare><GameGate gameId="find-object"><FindObjectGame /></GameGate></Bare>} />
          <Route path="/play/sort-match" element={<Bare><GameGate gameId="sort-match"><SortMatchGame /></GameGate></Bare>} />
          <Route path="/play/pattern" element={<Bare><GameGate gameId="pattern"><PatternGame /></GameGate></Bare>} />
          <Route path="/play/copycat" element={<Bare><GameGate gameId="copycat"><CopycatGame /></GameGate></Bare>} />
          <Route path="/play/shadow" element={<Bare><GameGate gameId="shadow"><ShadowGame /></GameGate></Bare>} />
          {/* legacy paths redirect to fresh games */}
          <Route path="/play/find-color" element={<Navigate to="/play/pattern" replace />} />
          <Route path="/play/count" element={<Navigate to="/play/copycat" replace />} />
          <Route path="/play/animal-sounds" element={<Navigate to="/play/shadow" replace />} />
          <Route path="/play/different" element={<Bare><GameGate gameId="different"><DifferentGame /></GameGate></Bare>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </SubProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
